module.exports = __webpack_public_path__ + "static/media/m3.6f76b687.webp";